import Vue from 'vue';
import VueRouter from 'vue-router';
import Quote from '@/views/Quote';
import Logout from '@/views/auth/Logout';
import Login from '@/views/auth/Login';
import NotFound from '@/views/NotFound';
import {
  auth
} from '@/middleware/auth';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/quote'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/quote',
    name: 'quote',
    component: Quote,
    meta: {
      requiresAuth: true,
      title: 'Quote'
    }
  },
    // Fall through 404 page
  {
    path: '*',
    name: 'notFound',
    component: NotFound,
    meta: {
      requiresAuth: true,
      title: 'Not Found'
    }
  }
  ]
});

router.beforeResolve(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    if (to.query.code) {
      /**
       * This is for when we are coming BACK FROM the Cognito auth, with a code in the URL
       */
      const loginPromise = new Promise((resolve, reject) => {
        auth.parseCognitoWebResponse(window.location.href);
      });
      await loginPromise;
    }
  
    // Remove path param
    if (to.query.path) {
      const nextPath = to.query.path;
      delete to.query.path;
      next({
        path: nextPath,
        query: to.query
      });
    }

    const user = await auth.getCurrentUser();
    // Log user in 
    if (!user) {
      next({name: 'login'});
    }
  }

  next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js